exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc-section[data-v-db3cae48]{padding:1.5rem;flex:none;display:flex;flex-direction:column;width:60%;border-left:none}@media(max-width:600px){.desc-section[data-v-db3cae48]{width:100%;border:none;padding-left:0;padding-right:0;padding-bottom:0}}", ""]);

// exports
